import React, {useState} from 'react';
import {
  Image,
  Text,
  TextInput,
  TextInputProps,
  TouchableOpacity,
  View,
} from 'react-native';
import {Images} from '../../constants/Images';
import {styles} from './styles';
interface IInput extends TextInputProps {
  title: string;
  mt?: number;
  hasSecurity?: boolean;
  hasForgetPassword?: boolean;
  forgetPassword?: () => void;
  error?: string;
}

const Input = ({
  title,
  placeholder,
  mt,
  hasSecurity,
  hasForgetPassword,
  forgetPassword,
  error,
  ...props
}: IInput) => {
  const [eye, setEye] = useState<boolean>(true);

  const toggleEye = () => {
    setEye(!eye);
  };

  return (
    <View style={{marginTop: mt}}>
      <Text style={styles.title}>{title}</Text>
      <View style={[styles.containerInput, error && styles.containerInputError]}>
        <TextInput
          placeholder={placeholder}
          style={hasSecurity? {...styles.input}: {...styles.FullInput}}
          secureTextEntry={hasSecurity ? eye : false}
          placeholderTextColor={'lightgray'}
          {...props}
        />
        {hasSecurity &&
          (eye ? (
            <TouchableOpacity
              onPress={toggleEye}
              style={{
                width: '10%',
              }}>
              <Image source={Images.closedEye} />
            </TouchableOpacity>
          ) : (
            <TouchableOpacity
              onPress={toggleEye}
              style={{
                width: '10%',
              }}>
              <Image source={Images.eye} />
            </TouchableOpacity>
          ))}
      </View>
      {hasForgetPassword && (
        <TouchableOpacity onPress={forgetPassword}>
          <Text style={styles.forget}>Esqueceu sua senha?</Text>
        </TouchableOpacity>
      )}
      {!!error && <Text style={styles.errorText}>{error}</Text>}
    </View>
  );
};

export default Input;
